import React from "react";
// import "./TipoCheckbox.css";

const TipoCheckbox = ({
  test,
  respuestasCheckbox,
  onResponderCheckbox,
  onFinalizar,
  className = "",
}) => {
  return (
    <>
      {test.todoUnaPag && test.imgGral && (
        <div className="pregunta-card">
          <p className="instruccion-img">{test.tituloPreguntaGral}</p>
          <div className={`pregunta-imagen ${className}`}>
            <img src={test.imgGral} alt="Imagen del test" />
          </div>
        </div>
      )}

      <div className="preguntas-checkbox-container">
        {test.ultimaInstruccion && (
          <p className="instruccion-img">{test.ultimaInstruccion}</p>
        )}
        {test.preguntas.map((pregunta) => (
          <div key={pregunta.id} className="pregunta-card">
            <p className="pregunta-texto-checkbox">
              {pregunta.textoPregunta.text}
            </p>

            <div className="opciones-checkbox">
              {pregunta.opciones.map((opcion, opcionIndex) => (
                <div
                  key={opcionIndex}
                  className={`checkbox-option ${
                    respuestasCheckbox[pregunta.id] === opcionIndex
                      ? "checked"
                      : ""
                  }`}
                  onClick={() => onResponderCheckbox(pregunta.id, opcionIndex)}
                >
                  <div className="checkbox-box">
                    {respuestasCheckbox[pregunta.id] === opcionIndex && (
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path
                          d="M16.6667 5L7.50004 14.1667L3.33337 10"
                          stroke="white"
                          strokeWidth="2.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    )}
                  </div>
                  <span className="checkbox-label">
                    {opcion.checkbox === "si" ? "Sí" : "No"}
                  </span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      <button onClick={onFinalizar} className="btn-continuar">
        Continuar
      </button>
    </>
  );
};

export default TipoCheckbox;